import { ExternalLink } from 'lucide-react';

import type { IpmaSourceAction } from '@/lib/sources';

interface Props {
  sources: IpmaSourceAction[];
}

const SourceLinks = ({ sources }: Props) => (
  <div
    aria-label="Sources"
    className="mt-2.5 flex flex-wrap items-center gap-1.5"
  >
    <span className="mr-0.5 text-[11px] font-medium text-muted-foreground/80">
      Sources
    </span>
    {sources.map((source) => (
      <a
        className="inline-flex max-w-full items-center gap-1 rounded-md border border-border/70 bg-background/50 px-2 py-1 text-[11px] font-medium text-muted-foreground transition-colors duration-150 hover:border-primary/35 hover:bg-primary/5 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
        href={source.url}
        key={source.id}
        rel="noopener noreferrer"
        target="_blank"
      >
        <span className="max-w-44 truncate">{source.label}</span>
        <ExternalLink aria-hidden="true" className="size-3 shrink-0" />
      </a>
    ))}
  </div>
);

export { SourceLinks };
